export class User {
    id!: number;
    slug!: string;
    email!: string;
    token!: string;
    username!: string;
    active!: boolean;
    role!: string;
    roleName!: string;
    displayName!: string;
    avatar!: string;
    timeZone!: string;
    user_token!: string;
    group!: any;
    first_name!: string;
    last_name!: string;
    user_email!: string;
    user_bu!: string;
    description_group!: string;
    title!: string;
    gender!: string;
    apscan_access_token!: string;
    phone!: string;
    adresse!: string;
    pagination_preferences?: { [pageId: string]: number }; // Préférences de pagination par page depuis la base de données
}